const UN_SUPPORTED_STYLES = [
  {
    "text-align": "start",
  },
  { "text-align": "end" },
];

export default UN_SUPPORTED_STYLES;
